exports = module.exports = require("/Volumes/Work/ITCase/baikal430/node_modules/css-loader/cssToString.js")();
exports.push([module.id, ".Next{font-size:1.7rem;display:block;padding:50px 20px 40px;color:#fff;background-color:#149be2}.Next__w{position:relative;z-index:1}.Next__w:before{position:absolute;left:0;top:-20px;width:120px;height:2px;content:\"\";background-color:#fff}.Next p{font-size:2.4rem;display:inline;margin:0 1rem 0 0}.Next p,.Next img{vertical-align:middle}", ""]);


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader/lib!./~/stylus-loader!./src/components/Next/Next.styl
// module id = 216
// module chunks = 0